import { render } from "./VabQueryFormBottomPanel.vue?vue&type=template&id=3973e3dd"
import script from "./VabQueryFormBottomPanel.vue?vue&type=script&lang=js"
export * from "./VabQueryFormBottomPanel.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/vab/components/VabQueryForm/components/VabQueryFormBottomPanel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3973e3dd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3973e3dd', __exports__)) {
    console.log('reload')
    api.reload('3973e3dd', __exports__)
  }
  
  module.hot.accept("./VabQueryFormBottomPanel.vue?vue&type=template&id=3973e3dd", () => {
    console.log('re-render')
    api.rerender('3973e3dd', render)
  })

}


export default __exports__